const shuttles = {
  shuttles: 'Transporte',

  toast: {
    error: {
      badResponse: '[Shuttle] resposta inválida do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[Shuttle] atualizado com sucesso',
      },
      delete: {
        default: '[Shuttle] excluído com sucesso',
      },
    },
  },

  create: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível Criar Transporte',
    },
    successToast: {
      message: 'sucesso! Transporte foi adicionado com sucesso',
    },
  },

  edit: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar o transporte',
    },
    successToast: {
      message: 'sucesso! A Viagem foi Atualizada com SUCESSO',
    },
  },

  createNew: 'Criar',
  deleteBtn: 'Remover',

  deleteModal: {
    header: 'Excluir os transportes',
    body: 'Você está prestes a excluir {{num}} transportes.',
  },
  table: {
    headers: {
      id: 'Identificação',
      line: 'Linha',
      direction: 'Direção',
      weekdays: 'Dias úteis',
      supplier: 'Fornecedor',
      pax: 'Pax',
    },
    notAvailable: 'Não disponível',
    actions: {
      duplicate: 'Duplicar',
      delete: 'Remover',
      export: 'Exportar',
    },
  },

  form: {
    header: {
      createShuttle: {
        title: 'Novo Transporte',
      },

      updateShuttle: {
        title: 'Transporte',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    info: {
      details: {
        header: {
          create: 'Criar transporte',
          edit: 'Editar transporte',
          information: 'Informações do transporte',
        },
        shuttleBy: {
          flexibleTime: 'Horário Flexível',
          fixedTime: 'Horário fixo',
        },
        fields: {
          unit: 'Local',
          supplier: 'Operado por',
          hour1: 'De',
          hour2: 'Para',
          shuttleBy: 'Passar por',
          code: 'Código',
          name: 'Nome',
          area: 'Zona',
          line: 'Linha',
          profile: 'Perfil',
          direction: 'Direção',
          weekDays: 'Dias da Semana',
          drivers: 'Motoristas',
          pax: 'Pax',
          paymentType: 'Tipo de pagamento',
          routingType: 'Tipo de Roteirização',
        },
        paymentTypeOptions: {
          free: 'Livre',
          opusCard: 'Cartão OPUS',
          cashOnBoard: 'Numerário',
          correspondance: 'Correspondência',
        },
        routingTypeOptions: {
          dynamic: 'Dinâmico',
          demand: 'Demanda',
          bus: 'Autocarro',
        },
      },
      times: {
        header: 'Tempo',
        fields: {
          hour: 'Hora',
          limit: 'Limite',
          busses: 'Ônibus',
          holidays: 'Feriados',
        },
        btnAdd: 'Adicione tempo',
      },
      stops: {
        header: 'Paradas',
        fields: {
          address: 'Endereço',
          name: 'Nome',
          zone: 'Zona',
          save: 'Editar',
        },
        btnAdd: 'Adicionar Parada',
      },
      zone: '( Zona: {{zone}})',
    },
    validation: {
      unitRequired: 'O local é obrigatório',
      codeRequired: 'O código é obrigatório',
      nameRequired: 'Campo de nomeação obrigatória',
      paxRequired: 'Pax é requerido',
      hourRequired: 'É requerido uma Hora',
      limitRequired: 'Limite é obrigatório',
      latRequired: 'A latitude é obrigatória',
      lonRequired: 'Longitude necessária',
    },
    weekDays: {
      sunday: 'Domingo',
      monday: 'Segunda-feira',
      tuesday: 'Terça-feira',
      wednesday: 'Quarta-feira',
      thursday: 'Quinta-feira',
      friday: 'Sexta-feira',
      saturday: 'Sábado',
    },
  },
};

export default shuttles;
